import { render, staticRenderFns } from "./project-list-type.html?vue&type=template&id=cbac85b4&"
import script from "./ProjectListType.vue?vue&type=script&lang=js&"
export * from "./ProjectListType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports